import React from 'react';
import { NavLink } from 'react-router-dom';

function GymSettingsButton() {
  return (
    <div className='gym-settings-container leading-divider'>
      <NavLink to='/app/settings' className='row-button' title='Gym Settings'>
        <img
          className='btnImg'
          alt='Gym Settings'
          src='resources/images/gear-icon.svg'
        />
      </NavLink>
    </div>
  );
}

export default GymSettingsButton;
